import { Badge } from 'react-bootstrap';
import { CartFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

function ProductSearchResultDisplayer({ products, hasSearched }) {
    const { t } = useTranslation('messages');

    if (!hasSearched) return null;

    if (products.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <CartFill size={48} className="mb-3 opacity-25" />
                <p className="mb-0">{t('main.store_search.empty_state')}</p>
            </div>
        );
    }

    return (
        <div>
            {products.map((product) => (
                <div key={product.link} className="card border-0 shadow-sm mb-3">
                    <div className="card-body p-3 d-flex gap-3 align-items-center">
                        {product.imageLink && (
                            <img
                                src={product.imageLink}
                                alt={product.name}
                                className="rounded flex-shrink-0"
                                style={{ width: 72, height: 72, objectFit: 'cover' }}
                            />
                        )}
                        <div className="flex-grow-1 min-w-0">
                            <a
                                href={product.link}
                                target="_blank"
                                rel="noreferrer"
                                className="fw-semibold text-dark text-decoration-none"
                            >
                                {product.name}
                            </a>
                            <div className="d-flex flex-wrap align-items-center gap-2 mt-1">
                                <span className="text-muted small">{product.shopName}</span>
                                <span className="fw-bold">{product.price}</span>
                                {product.status && (
                                    <Badge bg={getStatusVariant(product.status)} className="text-capitalize">
                                        {product.status}
                                    </Badge>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

function getStatusVariant(status) {
    const s = status.toLowerCase();
    if (s.includes('non') || s.includes('esaurit') || s.includes('unavailab')) return 'danger';
    if (s.includes('disponib') || s.includes('availab')) return 'success';
    return 'secondary';
}

export default ProductSearchResultDisplayer;
